// 테넌트별 로그인 브랜딩(로고/타이틀). 빌드 env VUE_APP_TENANT 로 선택.
// - kogasSignup.js 와 동일한 테넌트 토글 패턴(vue-cli-service build --mode kogas).
// - 로고는 public/branding/ 에 두고 BASE_URL(=publicPath, kogas는 /rmt) 로 참조 →
//   webpack import 아니라 URL 참조라 파일이 없어도 빌드가 깨지지 않는다.
// - 설정이 없으면 loginBrand === null → 로그인 화면은 기존 i18n 타이틀 그대로(로고 없음).

const TENANT = process.env.VUE_APP_TENANT || "default";

const BRANDING = {
  kogas: {
    logo: `${process.env.BASE_URL}branding/kogas-logo.png`,
    logoAlt: "한국가스기술공사",
    title: "AR 원격 기술지원 시스템",
    subtitle: "Sign in to your account",
    hideForgotPassword: true, // kogas 로그인 화면에서 "비밀번호 찾기" 숨김
    hideSignUp: true, // kogas 로그인 화면에서 하단 "회원가입" 안내 숨김
  },
};

// 신규 테넌트 추가는 위 객체에 한 항목만 넣으면 됨.
export const loginBrand = BRANDING[TENANT] || null;
